import { ReactElement, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { AxiosResultDefaultError } from '../../../../../../api/request';
import { AuthenticationError } from '../../../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../components/info/DisplayError';
import Loading from '../../../../../../components/info/Loading';
import { getSurvey } from '../../../api';
import { Survey } from '../../../types/Survey';

export interface SurveyPublishedEditLoaderProps {
  children: (props: {
    survey: Survey;
    refresh: () => Promise<void>;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  Survey,
  AuthenticationError | AxiosResultDefaultError
>();

export function useSurveyPublishedEditLoader() {
  return useFetch();
}

export default function SurveyPublishedEditLoader({
  children,
}: SurveyPublishedEditLoaderProps) {
  const { surveyId } = useParams<{ surveyId: string }>();

  const request = useCallback(async () => {
    return getSurvey(surveyId);
  }, [surveyId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          }

          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
              />
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="No se cargaron los datos"
                retryAction={refresh}
              />
            );
          }

          return children({ survey: data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
